<template>
  <div class="sound">
    <Header></Header>
    <Nav type="7" @getChildren="getChildren"></Nav>
    <Toptitle title="驿声影"></Toptitle>
    <div class="activitiesCommunity_nav">
      <a v-for="(item,index) of soundData" :key="index" :class="tip==index?'selection':''" @click="getDetail(index,item.value.id)">{{item.value.name}}</a>
    </div>
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
          <div class="swiper_img" @click="goBannerDetail(slide.paperid,slide.url)">
            <img :src="slide.picture" alt="">
            <span></span>
            <!-- <div class="i_img">
              <img src="../assets/static/images/playIcon.png" />
            </div> -->
            <p>{{slide.title}}</p>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev" slot="button-prev">

        </div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="sound_model sound_model_top" v-show="tip==0">
      <div class="h_title">
        <h3><i></i>旅伴音乐</h3>
        <span @click="goSoundMore('0')">更多></span>
      </div>
      <div class="sound_m_list" v-if="lbMusic.length>0">
        <div class="sound_m_item" v-for="(item,index) of lbMusic" :key="index" @click="goSoundDetail(item.id)">
          <div class="sound_m_item_img sound_m_item_img_s">
            <img :src="item.logo" />
            <div class="i_img">
              <img src="../assets/static/images/playIcon.png" />
            </div>
          </div>
          <p class="sound_m_p sound_m_p_tit">{{item.title}}</p>
          <p class="sound_m_p">{{item.subtitle}}</p>
          <p class="sound_m_p">类型：旅伴音乐</p>
        </div>
      </div>
      <div class="null" v-else>
        暂无旅伴音乐
      </div>
    </div>
    <div class="sound_model" v-show="tip==0">
      <div class="h_title">
        <h3><i></i>导游词</h3>
        <span @click="goSoundMore('1')">更多></span>
      </div>
      <div class="sound_m_list" v-if="dyMusic.length>0">
        <div class="sound_m_item" v-for="(item,index) of dyMusic" :key="index" @click="goSoundDetail(item.id)">
          <div class="sound_m_item_img sound_m_item_img_s">
            <img :src="item.logo" />
            <div class="i_img">
              <img src="../assets/static/images/playIcon.png" />
            </div>
          </div>
          <p class="sound_m_p">{{item.title}}</p>
          <p class="sound_m_p">{{item.subtitle}}</p>
          <p class="sound_m_p">类型：导游词</p>
        </div>
      </div>
      <div class="null" v-else>
        暂无导游词
      </div>
    </div>
    <div class="sound_model sound_model_b" v-show="tip==0">
      <div class="h_title">
        <h3><i></i>主题曲</h3>
        <span @click="goSoundMore('2')">更多></span>
      </div>
      <div class="sound_m_list" v-if="ztMusic.length>0">
        <div to="soundDetail" class="sound_m_item" v-for="(item,index) of ztMusic" :key="index" @click="goSoundDetail(item.id)">
          <div class="sound_m_item_img sound_m_item_img_s">
            <img :src="item.logo" />
            <div class="i_img">
              <img src="../assets/static/images/playIcon.png" />
            </div>
          </div>
          <p class="sound_m_p">{{item.title}}</p>
          <p class="sound_m_p">{{item.subtitle}}</p>
          <p class="sound_m_p">类型：主题曲</p>
        </div>
      </div>
      <div class="null" v-else>
        暂无导游词
      </div>
    </div>



    <div class="sound_model sound_model_top" v-show="tip==1">
      <div class="h_title">
        <h3><i></i>旅伴视频</h3>
        <span @click="goVideoMore(17)">更多></span>
      </div>
      <div class="sound_m_list" v-if="lbVideo.length>0">
        <div to="soundDetail" class="sound_m_item" v-for="(item,index) of lbVideo" :key="index" @click="goVideoDetail(item.id)">
          <div class="sound_m_item_img">
            <img :src="item.picture" />
            <div class="i_img">
              <img src="../assets/static/images/playIcon.png" />
            </div>
          </div>
          <p class="sound_m_p">{{item.title}}</p>
          <p class="sound_m_p">{{item.subtitle}}</p>
          <p class="sound_m_p">类型：旅伴视频</p>
        </div>
      </div>
      <div class="null" v-else>
        暂无旅伴视频
      </div>
    </div>
    <div class="sound_model" v-show="tip==1">
      <div class="h_title">
        <h3><i></i>导游视频</h3>
        <span @click="goVideoMore(18)">更多></span>
      </div>
      <div class="sound_m_list" v-if="dyVideo.length>0">
        <div to="soundDetail" class="sound_m_item" v-for="(item,index) of dyVideo" :key="index" @click="goVideoDetail(item.id)">
          <div class="sound_m_item_img">
            <img :src="item.picture" />
            <div class="i_img">
              <img src="../assets/static/images/playIcon.png" />
            </div>
          </div>
          <p class="sound_m_p">{{item.title}}</p>
          <p class="sound_m_p">{{item.subtitle}}</p>
          <p class="sound_m_p">类型：导游视频</p>
        </div>
      </div>
      <div class="null" v-else>
        暂无导游视频
      </div>
    </div>
    <div class="sound_model sound_model_b" v-show="tip==1">
      <div class="h_title">
        <h3><i></i>主题视频</h3>
        <span @click="goVideoMore(19)">更多></span>
      </div>
      <div class="sound_m_list" v-if="ztVideo.length>0">
        <div to="soundDetail" class="sound_m_item" v-for="(item,index) of ztVideo" :key="index" @click="goVideoDetail(item.id)">
          <div class="sound_m_item_img">
            <img :src="item.picture" />
            <div class="i_img">
              <img src="../assets/static/images/playIcon.png" />
            </div>
          </div>
          <p class="sound_m_p">{{item.title}}</p>
          <p class="sound_m_p">{{item.subtitle}}</p>
          <p class="sound_m_p">类型：主题视频</p>
        </div>
      </div>
      <div class="null" v-else>
        暂无导游视频
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  import 'swiper/dist/css/swiper.css'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        swiperOption: {
          notNextTick: true,
          // autoplay: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        swiperSlides: [],
        soundData: [],
        tip: 0,
        navID: '',
        videoNavID: '',
        lbMusic: [],
        dyMusic: [],
        ztMusic: [],
        lbVideo: [],
        dyVideo: [],
        ztVideo: []
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      swiper,
      swiperSlide,
      Toptitle
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    methods: {
      getDetail(index, id) {
        this.tip = index
        this.navID = id
        this.videoNavID = id
        this.getBanner()
        if (this.tip == 0) {
          this.getAlbumList('0') //获取旅伴音乐
          this.getAlbumList('1') //获取导游词
          this.getAlbumList('2') //获取主题曲
        } else {
          this.getLive(17) //获取旅伴视频
          this.getLive(18) //获取导游视频
          this.getLive(19) //获取主题视频
        }

      },
      getBanner() {
        this.axios.post('api/b_bannermag/getListByNavId.do', this.qs({
          navigateid: this.navID
        })).then(res => {
          if (res.status == 200) {
            this.swiperSlides = res.data.data
          }
        })
      },
      getAlbumList(type) {
        this.axios.post('api/m_issuemag/getList.do', this.qs({
          navigateid: this.navID,
          params: {type:type},
          pageNo: 1,
          pageSize: 4
        })).then(res => {
          if(res.status==200){
            if(type=='0'){
              this.lbMusic=res.data.page.results
            }else if(type=='1'){
              this.dyMusic=res.data.page.results
            }else if(type=='2'){
              this.ztMusic=res.data.page.results
            }
          }
        })
      },
      getLive(type) {
        this.axios.post('api/c_article/getListByNavIdAndTypeId.do', this.qs({
          navigateid: this.navID,
          typeid: type,
          pageNo: 1,
          pageSize: 4
        })).then(res => {
          if (res.status == 200) {
            if (this.tip == 1) {
              if (type == 17) {
                this.lbVideo = res.data.results
              } else if (type == 18) {
                this.dyVideo = res.data.results
              } else if (type == 19) {
                this.ztVideo = res.data.results
              }
            }
          }
        })
      },
      getChildren(data) {
        this.soundData = data
        this.navID = this.soundData[0].value.id
        this.getBanner()
        this.getAlbumList('0') //获取旅伴音乐
        this.getAlbumList('1') //获取导游词
        this.getAlbumList('2') //获取主题曲
      },
      goSoundMore(type) { //跳转更多
        this.$router.push({
          name: 'soundMore',
          query: {
            navID: this.navID,
            type: type
          }
        })
      },
      goVideoMore(type) {
        this.$router.push({
          name: 'videoMore',
          query: {
            navID: this.videoNavID,
            type: type
          }
        })
      },
      goSoundDetail(id) {
        this.$router.push({
          name: 'albumList',
          query: {
            id: id
          }
        })
      },
      goVideoDetail(id) {
        this.$router.push({
          name: 'videoDetail',
          query: {
            id: id
          }
        })
      },
      goBannerDetail(id, url) {
        if (url != '') {
          window.open(url)
        } else {
          this.$router.push({
            name: 'articleDetail',
            query: {
              id: id
            }
          })
        }

      },

    },
    mounted() {
      if (sessionStorage.getItem('sound')) {
        this.soundData = JSON.parse(sessionStorage.getItem('sound'))
        this.navID = this.soundData[0].value.id
        this.videoNavID = this.soundData[1].value.id
        this.getBanner()
        this.getAlbumList('0') //获取旅伴音乐
        this.getAlbumList('1') //获取导游词
        this.getAlbumList('2') //获取主题曲
      }

    },
    beforeRouteLeave (to, from, next) {
        console.log(to);
        if(to.name == 'albumList'){
          to.meta.keepAlive = true
        }
        console.log(to);
        next()
    }
  }
</script>

<style>
.sound_m_p_tit{font-weight: 600;margin-top: 10px;}
</style>
